import { useState } from 'react';

const useDeepInsights = () => {
  const [deepInsights, setDeepInsights] = useState(false);
  const [logs, setLogs] = useState([]);

  const handleToggle = () => {
    setDeepInsights(false);
  };

  const handleLogs = (entry) => {
    setLogs((prev) => [...prev, { timestamp: entry.timestamp, content: entry.content }]);
  };

  const clearLogs = () => {
    setLogs([]);
  };

  return { deepInsights, setDeepInsights, logs, handleToggle, handleLogs, clearLogs };
};

export default useDeepInsights;
